export const currentYear = new Date().getFullYear().toString();

export const TOKEN_STORAGE_KEY = '@gabarito/token';
export const USER_NAME_STORAGE_KEY = '@gabarito/user-name';
export const TOKEN_VALID_TIME_STORAGE_KEY = '@gabarito/expires_in';
export const TOKEN_USER_ID_STORAGE_KEY = '@gabarito/user-id';

